import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/components/images/see-more.png'


const _hoisted_1 = {
  class: "BackDialog",
  "data-test": "back-dialog"
}
const _hoisted_2 = { class: "BackDialog__container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "BackDialog__title" }, [
  /*#__PURE__*/_createElementVNode("p", null, "真的要离开嘛？ "),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" 下次可从 "),
    /*#__PURE__*/_createElementVNode("span", null, "【发现】"),
    /*#__PURE__*/_createTextVNode(" 这里来找我哦")
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "BackDialog__block" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "BackDialog__img",
    src: _imports_0
  })
], -1)
const _hoisted_5 = { class: "BackDialog_btns" }

import { close_page } from '@kk/h5-sdk';

export default /*#__PURE__*/_defineComponent({
  emits: ["close"],
  setup(__props, { emit }: { emit: ({
  (e: 'close'): void;
}), expose: any, slots: any, attrs: any }) {



function onClose (close: number | undefined) {
  close && close_page({ animation: 1 });
  emit('close');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: "btn",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (onClose(1)), ["stop"]))
        }, "残忍离开"),
        _createElementVNode("div", {
          class: "btn",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (onClose()), ["stop"]))
        }, "再玩一会")
      ])
    ])
  ]))
}
}

})